// @flow
import toCamelCase from 'app/common/lib/util/toCamelCase';

const upperFirst = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

export default function toPascalCase(s: string): string {
  return upperFirst(toCamelCase(s));
}
